import { MESApiService } from "@dexteel/mesf-core";
import { get } from "lodash-es";

export type DelayAsset = {
	AssetId: number;
	AssetName: string;
};

export type GroupedDelayAsset = DelayAsset & {
	ParentAssetId: number | null;
	ParentAssetName: string | null;
};

export const getDelayAssets = async () => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[DEL].[GetDelayAssets]", []);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as DelayAsset[];
	} else {
		throw new Error(resp.message || "Error fetching delay assets");
	}
};

export const getDelayAssetsGrouped = async () => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[DEL].[GetDelayAssetsGrouped]", []);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as GroupedDelayAsset[];
	} else {
		throw new Error(resp.message || "Error fetching grouped delay assets");
	}
};
